// @flow
import $ from "jquery";
import * as Immutable from "immutable";
import React from "react";
import Spinner from "react-spin";
import type { GazelleData } from "../types/gazelle.js";
import { fetchGazellePreviewData } from "../utils/gazelle.js";
import ApModal from "./ApModal.js";
import VerticalStackContainer from "./gazelle/VerticalStackContainer.js";
import "./SummaryPreviewContainer.scss";

type Props = {
  updateNativeInputsFn: () => void
};

export default class SummaryPreviewContainer extends React.Component {
  state: {
    isModalOpen: boolean,
    isLoading: boolean,
    gazelleData: GazelleData
  };
  props: Props;

  constructor(props: Props) {
    super(props);
    (this: any).onButtonClick = this.onButtonClick.bind(this);
    this.state = {
      isModalOpen: false,
      isLoading: false,
      gazelleData: Immutable.List()
    };
  }

  onButtonClick(evt: Event) {
    evt.preventDefault();

    var body = {
      type: "summary",
      ap_object_id: window.initial_js_data.ap_object_pk,
      data: {}
    };

    // If on the summary update page, override what we can with the latest
    // field values
    if (window.location.pathname.includes("/summary/update/")) {
      this.props.updateNativeInputsFn();
      body.data = {
        description: $("#id_description").val(),
        production_info: $("#id_production_info").val(),
        overview_title: $("#id_overview_title").val(),
        overview_body: $("#id_overview_body").val()
      };
    }

    fetchGazellePreviewData(body).then(gazelleData => {
      this.setState({
        gazelleData: gazelleData,
        isLoading: false
      });
    });
    this.setState({ isModalOpen: true, isLoading: true });
  }

  render() {
    let modalBody = null;
    if (this.state.isLoading) {
      modalBody = <Spinner />;
    } else {
      modalBody = (
        <VerticalStackContainer gazelleData={this.state.gazelleData} />
      );
    }
    return (
      <div>
        <a className="summary-preview-btn btn" onClick={this.onButtonClick}>
          Summary Preview
        </a>
        <ApModal
          title="Summary Preview"
          isOpen={this.state.isModalOpen}
          onRequestClose={() => this.setState({ isModalOpen: false })}
        >
          <div style={{ width: "320px" }}>{modalBody}</div>
        </ApModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/SummaryPreviewContainer.js